import { User } from '../../services/userService';

interface UserAvatarProps {
  currentUser?: User | null;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  xs: 'w-4 h-4 text-[8px]',
  sm: 'w-6 h-6 text-xs',
  md: 'w-8 h-8 text-sm',
  lg: 'w-10 h-10 text-base'
};

export default function UserAvatar({ currentUser, size = 'md', className = '' }: UserAvatarProps) {
  const userPhoto = currentUser?.image_url;
  const userName = currentUser?.display_name || currentUser?.username || 'You';
  const sizeClass = sizeClasses[size];

  if (userPhoto) {
    return (
      <img 
        src={userPhoto} 
        alt={userName} 
        className={`${sizeClass} rounded-full object-cover ${className}`}
      />
    );
  }

  return (
    <div className={`${sizeClass} rounded-full bg-gray-300 dark:bg-gray-600 flex items-center justify-center font-medium text-gray-700 dark:text-gray-300 ${className}`}>
      {userName.charAt(0).toUpperCase()}
    </div>
  );
}

